import featureFlags from "@/constants/feature-flags";
import { components } from "@/lib/openapi/schemas/service-telegram-authorization";
import useMeQuery from "./use-me-query";
import useUpdateFeatureFlagsMutate from "./use-update-feature-flags-mutate";

const useFeatureFlags = ({
  user,
  onSuccess,
  onError,
}: {
  user?: components["schemas"]["UserResponse"];
  onSuccess?: (newData: (keyof typeof featureFlags)[]) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const { data: currentUser } = useMeQuery();
  const { mutate, mutateAsync, isPending } = useUpdateFeatureFlagsMutate({
    queryOptions: {
      onSuccess: (response) => {
        onSuccess?.(
          (response.featureFlags ?? []) as (keyof typeof featureFlags)[],
        );
      },
      onError,
    },
  });

  const selectedUser = user ?? currentUser;

  const set = (newFeatureFlags: (keyof typeof featureFlags)[]) => {
    return mutate({
      body: {
        featureFlags: newFeatureFlags,
        userId:
          selectedUser?._id === currentUser?._id
            ? undefined
            : selectedUser?._id,
      },
    });
  };

  const setAsync = async (newFeatureFlags: (keyof typeof featureFlags)[]) => {
    return ((await mutateAsync({
      body: {
        featureFlags: newFeatureFlags,
        userId:
          selectedUser?._id === currentUser?._id
            ? undefined
            : selectedUser?._id,
      },
    })).featureFlags ?? []) as (keyof typeof featureFlags)[];
  };

  const userFeatureFlags = (selectedUser?.featureFlags ?? []) as (keyof typeof featureFlags)[];

  return {
    featureFlags: userFeatureFlags,
    set,
    setAsync,
    isPending
  };
};

export default useFeatureFlags;
